import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ProgressLoader from '../ProgressLoader';
import StyledLoadingWrapper from './StyledLoadingWrapper';

const LoadingWrapper = ({
	children = null,
	isLoading = false,
	className = null,
	blockContent = false,
	spacing = 'md',
	loaderSize = 'md'
}) => {
	const loaderProps = {
		size: loaderSize
	};

	const props = {
		className: classNames(`spacing-${spacing}`, {
			[`${className}`]: !!className,
			loading: isLoading,
			block: blockContent
		})
	};

	return (
		<StyledLoadingWrapper {...props}>
			{children}
			{isLoading && <ProgressLoader {...loaderProps} />}
		</StyledLoadingWrapper>
	);
};

LoadingWrapper.propTypes = {
	isLoading: PropTypes.bool,
	className: PropTypes.string,
	blockContent: PropTypes.bool,
	spacing: PropTypes.oneOf(['none', 'sm', 'md']),
	loaderSize: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
};

export default LoadingWrapper;
